import { forwardRef } from "react";
function SvgCleverSvg({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={28}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="#fff"
        d="M13.328 27.333C5.672 27.333 0 21.476 0 14.073v-.065C0 6.67 5.574.667 13.557.667c4.902 0 7.836 1.627 10.246 3.986l-3.64 4.132c-2-1.806-4.048-2.912-6.638-2.912-4.377 0-7.541 3.612-7.541 8.037v.082c0 4.425 3.082 8.102 7.54 8.102 2.968 0 4.787-1.171 6.837-3.026L24 22.712c-2.689 2.848-5.656 4.621-10.672 4.621Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCleverSvg);
export default ForwardRef;
